import React from "react";
import { Link } from "react-router-dom";

// CSS File 
import '../../../assets/css/Toasters.css';

import { SiTicktick } from "react-icons/si";

/* This toaster appears when the user successfully creates a checklist */

const CreatedSuccesFullyToaster =  ({heading}) => {

    return (
        <div className="login-toaster-component-container">

            <div className="login-toaster-container">

                <div className="logins-tick-container">
                    <SiTicktick className="login-tick" />
                </div>

                <div className="logins-text-container">

                    <div>
                        <h1>{heading}</h1>
                    </div>

                    <div className="logins-text-container">
                        <p>One moment. Redirecting you to view created checklist page</p>
                    </div>

                </div>

                <div className="loading-circle">
                
                </div> {/* Replaced the "O" with the loading circle */}

                

            </div>

        </div>
    )
}

export default CreatedSuccesFullyToaster;
